// extracted by mini-css-extract-plugin
export default {"controller":"style_controller__N7QEN","menuContent":"style_menuContent__eqou+"};